import React from "react";
import { Modal, Button } from "react-bootstrap";
import { SlClose } from "react-icons/sl";
import { RiDeleteBin6Line } from "react-icons/ri";

const DeleteModal = ({
    show,
    onClose,
    onConfirm,
    title = "Confirm Delete",
    message = "Are you sure you want to delete this item? This action cannot be undone.",
    confirmText = "Delete",
    cancelText = "",
    isIcon = true,
    cancelButtonStyle = "",
    confirmButtonStyle = "",
    body = null,
    modalCentered = true,
}) => {
    return (
        <Modal show={show} onHide={onClose} backdrop="static" centered={modalCentered} dialogClassName="custom-modal">
            <Modal.Header closeButton className="!m-0 !border-none">
                <Modal.Title className="!font-semibold">{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body className="!py-0 ">
                {body ? body : <p>{message}</p>}
            </Modal.Body>

            <Modal.Footer className="flex !justify-start !border-none !pt-0">
                {cancelText > "" && <button
                    className={`flex items-center !px-[16px] h-[30px] !font-bold !rounded-[4px] gap-1 ${cancelButtonStyle}`}
                    onClick={onClose}
                >
                    {cancelText}
                </button>}

                <button
                    className={`flex items-center bg-[#dc3545] text-black !px-[16px] h-[30px] !font-bold !rounded-[4px] gap-1 ${confirmButtonStyle}`}
                    onClick={onConfirm}
                >
                    {/* {isIcon && <RiDeleteBin6Line size={20} />} */}
                    {confirmText}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteModal;
